import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMarkerOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 14 19",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.96344 0.700012C8.62462 0.700012 10.2178 1.35991 11.3924 2.53455C12.567 3.70918 13.2269 5.30232 13.2269 6.9635C13.2269 9.92571 8.6337 15.3033 7.31503 17.3652C7.27725 17.4242 7.22525 17.4727 7.16381 17.5063C7.10237 17.5399 7.03347 17.5575 6.96344 17.5575C6.89341 17.5575 6.82451 17.5399 6.76307 17.5063C6.70163 17.4727 6.64963 17.4242 6.61185 17.3652C5.29318 15.3041 0.699951 9.92571 0.699951 6.9635C0.699951 5.30232 1.35985 3.70918 2.53448 2.53455C3.70912 1.35991 5.30226 0.700012 6.96344 0.700012Z",
		stroke: "currentColor",
		strokeWidth: 1.4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 6.9634,
		cy: 6.9635,
		r: 2.2,
		stroke: "currentColor",
		strokeWidth: 1.4,
		fill: "none"
	})]
});
export default SvgMarkerOutline;
